export default __webpack_public_path__ + "static/media/40-bear-thai.ab4e57d0.jpg";